// Safari viewport height fix
function fixIosVh() {
  // Get the actual viewport height
  let vh = window.innerHeight * 0.01;
  // Set the value as a CSS variable
  document.documentElement.style.setProperty('--real-vh', `${vh * 100}px`);
}

// Run on page load
fixIosVh();

// Update on resize and orientation change
window.addEventListener('resize', fixIosVh);
window.addEventListener('orientationchange', fixIosVh);